import isPhoneApp from "./phone-app-communication/is-phone-app"

export const addHoverClass = (className: string, classWithHover: string) => {
    if (isPhoneApp()) {
        return className;
    }
    return [className, classWithHover].join(" ");
}